export default function FixedCTA() {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-2xl z-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 py-2.5 sm:py-3">
        <div className="grid grid-cols-2 gap-2 sm:gap-3">
          <a 
            href="tel:047-401-0700"
            className="flex items-center justify-center gap-1.5 sm:gap-2 bg-[#ff8c42] text-white py-3 sm:py-4 rounded-full font-bold hover:bg-[#ff7a2e] transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base"
          >
            <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center bg-white/20 rounded-full">
              <i className="ri-phone-fill text-base sm:text-lg"></i>
            </div>
            <span className="hidden xs:inline">無料相談</span>
            <span className="xs:hidden">電話</span>
          </a>
          
          <a 
            href="https://lin.ee/0Rgwq5v1"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-1.5 sm:gap-2 bg-[#1a2b4a] text-white py-3 sm:py-4 rounded-full font-bold hover:bg-[#2a3b5a] transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base"
          >
            <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
              <i className="ri-line-fill text-base sm:text-lg"></i>
            </div>
            <span className="hidden xs:inline">LINEで無料相談</span>
            <span className="xs:hidden">LINE</span>
          </a>
        </div>
      </div>
    </div>
  );
}